import type { FaireProductEntity } from "../../entity_types/product";

export const p_ekup7bw6cz: FaireProductEntity = {
  token: "p_ekup7bw6cz",
  type: "product",
  name: "Bee Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/e7d67b35e8b2f821b1b70eb74a4440ffbe25c5aace4a375d2f955aa0623621a2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c7b759b389d431d65808d7cabe13d2440fd679db9488b2c29f124bef93b04e7.jpeg",
    "https://cdn.faire.com/fastly/f5991e47984760e284e4662d2a664001c9937d15c0b3fc5969d5056c0ea33392.jpeg",
    "https://cdn.faire.com/fastly/42fb748595acd0f9dc405918d2ee93c6a18e717667532babdab4b598a2274eb5.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:30.873Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
